import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { tagKeys } from '@/shared/lib/query/queryKeys';

import { createClassificationApi } from '@/features/tags/api';
import type { CreateClassificationRequest } from '@/features/tags/api';

export const useCreateClassification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateClassificationRequest) => createClassificationApi(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tagKeys.categories() });

      notification.success({
        message: NOTIFICATION_MESSAGES.CLASSIFICATION_CREATE_SUCCESS,
        description: NOTIFICATION_MESSAGES.CLASSIFICATION_CREATE_SUCCESS_DESC,
        placement: 'bottomLeft',
        duration: 3,
      });
    },
  });
};
